import React from 'react'

function Produdcts() {
    return (
        <div>
            <h1>Products Page</h1>
        </div>
    )
}

export default Produdcts
